var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 31,
    height: 31,
    rx: 11.5,
    stroke: "#F2F9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5624 20.584V24.0625C13.5624 24.3055 13.7184 24.5207 13.9494 24.5972C14.0072 24.616 14.0664 24.625 14.1249 24.625C14.3004 24.625 14.4699 24.5425 14.5779 24.3955L16.6127 21.6265L13.5624 20.584Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7637 7.47932C24.5912 7.35707 24.3647 7.34057 24.1772 7.43882L7.30228 16.2513C7.10278 16.3555 6.98503 16.5685 7.00153 16.7928C7.01878 17.0178 7.16803 17.2098 7.38028 17.2825L12.0715 18.886L22.0622 10.3436L14.3313 19.6578L22.1935 22.345C22.252 22.3645 22.3135 22.375 22.375 22.375C22.477 22.375 22.5782 22.3473 22.6675 22.2933C22.81 22.2063 22.9067 22.06 22.9315 21.8958L24.994 8.02081C25.0247 7.81082 24.9362 7.60232 24.7637 7.47932Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.2aa515fda43b7a1b1e498bfcef7ceae1.svg";
export { ForwardRef as ReactComponent };